/** Shared layout constants for StartMany swipe sheet + embed map padding. */
export const START_MANY_SHEET_COLLAPSED_TOP_RATIO = 0.34;
export const START_MANY_SHEET_EXPANDED_PEEK_PX = 68;
